import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import NavBar from "../NavBar";
import Footer from "../Footer";
import {faq_s} from "../../data";
import Accordion from "../../Common/Accordion";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemHeading,
//   AccordionItemButton,
//   AccordionItemPanel,
// } from '../../Common/Lib/react-accessible-accordion/accordian/es';
// import '../../Common/Lib/react-accessible-accordion/styles/fancy-example.css';
import "./FAQPage.css";

//import {Link} from "react-router-dom";

function App() {
  return <X11FAQsPageDesktop {...x11FAQsPageDesktopData} />;
}

export default App;

function X11FAQsPageDesktop(props) {
  const {
    line4,
    line5,
    line6,
    line7,
    line8,
    bigrid3x2GapProps,
    bigrid3x2Gap2Props,
    frame1590Props,
    headerWithBackground3Props,
  } = props;

  return (
    <div className="faqpd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | FAQ’s</title>
        <meta name="keywords" content="Construction FAQ’s, construction company FAQ’s, house construction FAQ’s, commercial construction FAQ’s, interior designing FAQ’s, packages FAQ’s" />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="faqpd-x11-faq-s-page-desktop">
        <div className="faqpd-overlap-group">
          <div className="faqpd-group-89">
            {/* <img className="faqpd-line-4" src={line4} />
            <img className="faqpd-line" src={line5} />
            <img className="faqpd-line" src={line6} />
            <img className="faqpd-line" src={line7} /> */}
            <Bigrid3x2Gap src={bigrid3x2GapProps.src} />
            <Bigrid3x2Gap src={bigrid3x2Gap2Props.src} className={bigrid3x2Gap2Props.className} />
            {/* <img className="faqpd-line-8" src={line8} /> */}
          </div>
          <Frame1570 {...frame1590Props} />
          {/* <HeaderWithBackground32 {...headerWithBackground3Props} /> */}
          <NavBar />
        </div>
      </div>
    </div>
  );
}


function Bigrid3x2Gap(props) {
  const { src, className } = props;

  return (
    <div className={`faqpd-bigrid-3x2-gap ${className || ""}`}>
      <img className="faqpd-vector" src={src} />
    </div>
  );
}


function Frame1570(props) {
  const {
    faqs,
  } = props;

  return (
    <div className="faqpd-frame-1570">
      <h1 className="faqpd-fa-qs faqpd-valign-text-middle faqpd-typographyheadlineh2-extrabold-40">{faqs}</h1>
      
      {/* <img className="faqpd-rectangle-85" src={rectangle85} /> */}
      
      <img className="faqpd-rectangle-85" src={faq_s.FAQsHeader} alt="Webuildd FAQs" />
      <div className="faqpd-frame-1653">
        {/* <div className="faqpd-frame-1589 faqpd-border-1px-black-2"> */}
        <div className="faqpd-frame-1591">
        <Accordion/>
      </div>
        
      </div>
      
      <Footer />


    </div>
  );
}


function Close(props) {
  const { src } = props;

  return (
    <div className="faqpd-close">
      <img className="faqpd-vector-1" src={src} />
    </div>
  );
}


function Frame15905(props) {
  const { text102, plusProps } = props;

  return (
    <div className="faqpd-frame-159">
      <div className="faqpd-text-3 faqpd-valign-text-middle faqpd-typographyheadlineh4-extrabold-24">{text102}</div>
      {/* <Plus src={plusProps.src} /> */}
    </div>
  );
}


function Plus(props) {
  const { src } = props;

  return (
    <div className="faqpd-plus">
      <img className="faqpd-vector-2" src={src} />
    </div>
  );
}


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="faqpd-footer">
//       <div className="faqpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Frame1578(props) {
  const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="faqpd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="faqpd-frame-1584">
        <Group324 />
        <div className="faqpd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="faqpd-instagram">
            <div className="faqpd-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img
                className="faqpd-vector-3"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-56@2x.svg"
              />
              <img className="faqpd-vector-4" src={vector2} />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="faqpd-group-86">
      <White src={whiteProps.src} />
      <img className="faqpd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="faqpd-white">
      <img className="faqpd-vector-5" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="faqpd-group-32">
      <div className="faqpd-group-189">
        <div className="faqpd-map-pin-1">
          <div className="faqpd-overlap-group1-1">
            <img
              className="faqpd-vector-6"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-51@2x.svg"
            />
          </div>
        </div>
        <p className="faqpd-text-1 faqpd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="faqpd-group-18">
        <div className="faqpd-phone">
          <img
            className="faqpd-vector-7"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
          />
        </div>
        <div className="faqpd-text faqpd-valign-text-middle faqpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="faqpd-group-18">
        <div className="faqpd-mail">
          <div className="faqpd-overlap-group1-2">
            <img
              className="faqpd-vector-8"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-54@2x.svg"
            />
          </div>
        </div>
        <div className="faqpd-text faqpd-valign-text-middle faqpd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="faqpd-facebook-app-symbol">
      <img className="faqpd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="faqpd-twitter">
      <img className="faqpd-vector-9" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="faqpd-frame-5">
      <div className="faqpd-text-4 faqpd-valign-text-middle faqpd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="faqpd-frame-4">
      <div className="faqpd-text-2 faqpd-valign-text-middle faqpd-typographybody16-regular">{text41}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text42}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text43}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text44}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text45}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text46}</div>
      <div className="faqpd-text-5 faqpd-valign-text-middle faqpd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="faqpd-frame-6">
      <div className="faqpd-text-12 faqpd-valign-text-middle faqpd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="faqpd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`faqpd-frame-4-1 ${className || ""}`}>
      <div className="faqpd-text-13 faqpd-valign-text-middle faqpd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="faqpd-frame-1580">
        <div className="faqpd-text-1-1 faqpd-valign-text-middle faqpd-typographybody16-regular">{text50}</div>
        <div className="faqpd-place faqpd-valign-text-middle faqpd-typographybody16-regular">{place}</div>
        <div className="faqpd-text-15 faqpd-valign-text-middle faqpd-typographybody16-regular">{text51}</div>
        <div className="faqpd-text-16 faqpd-valign-text-middle faqpd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="faqpd-frame-7">
      <div className="faqpd-text-20 faqpd-valign-text-middle faqpd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


// function HeaderWithBackground32(props) {
//   const {
//     unselectedI2601291,
//     unselectedI26012912,
//     unselectedI26012913,
//     unselectedI26012914,
//     unselectedI26012915,
//     unselectedI26012916,
//     text108,
//     unselectedI26012917,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="faqpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="faqpd-frame-34">
//         <div className="faqpd-frame-27">
//           <Link to="/">
//           <div className="faqpd-unselected-i2601291 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI2601291}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="faqpd-unselected-i2601291-1 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012912}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="faqpd-unselected-i2601291-2 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012913}
//           </div>
//           </Link>
//           <Link to="/video">
//           <div className="faqpd-unselected-i2601291-3 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012914}
//           </div>
//           </Link>
//           <Link to="/insight">
//           <div className="faqpd-unselected-i2601291-4 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012915}
//           </div>
//           </Link>
//           <Link to="/blog">
//           <div className="faqpd-unselected-i2601291-5 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012916}
//           </div>
//           </Link>
//           <div className="faqpd-selected">
//             <div className="faqpd-overlap-group1-3">
//               <div className="faqpd-rectangle-61"></div>
//               <div className="faqpd-text-36 faqpd-valign-text-middle">{text108}</div>
//             </div>
//           </div>
//           <Link to="/contactus">
//           <div className="faqpd-unselected-i2601291-6 faqpd-valign-text-middle faqpd-typography-body-smalltext-14-regular">
//             {unselectedI26012917}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="faqpd-group-86-1">
      <White src={whiteProps.src} />
      <img className="faqpd-group-85-1" src={group85} />
    </div>
  );
}


function GetAQuoteButton222(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601291764120TimelineData);
  }, []);

  return (
    <div className="faqpd-i26012917-64120 faqpd-component faqpd-component-wrapper not-ready">
      <div className="faqpd-master-button-I5eVD6">
        <div className="faqpd-button-i2601291764-pB2G9G faqpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601291764120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".i26012917-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];

const bigrid3x2GapData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-107@2x.svg",
};

const bigrid3x2Gap2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-106@2x.svg",
    className: "faqpd-bigrid-3x2-gap-1",
};

const closeData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-118@2x.svg",
};

// const plusData = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame15905Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plusData,
};

// const plus2Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame159052Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plus2Data,
};

// const plus3Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame159053Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plus3Data,
};

// const plus4Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame159054Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plus4Data,
};

// const plus5Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame159055Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plus5Data,
};

// const plus6Data = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
// };

const frame159056Data = {
    text102: "Lorem Ipsum passages ?",
    // plusProps: plus6Data,
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-117@2x.svg",
};

const frame1578Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-57@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter3Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "faqpd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const frame1570Data = {
    faqs: "FAQ’s",
    rectangle85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/rectangle-85-4@2x.jpg",
    text28: "Lorem Ipsum passages ?",
    text29: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    closeProps: closeData,
    frame1590Props: frame15905Data,
    frame15902Props: frame159052Data,
    frame15903Props: frame159053Data,
    frame15904Props: frame159054Data,
    frame15905Props: frame159055Data,
    frame15906Props: frame159056Data,
    //footer32Props: footer32Data,
};

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: white2Data,
};

const getAQuoteButton222Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground32Data = {
//     unselectedI2601291: "HOME",
//     unselectedI26012912: "ABOUT US",
//     unselectedI26012913: "PROJECTS",
//     unselectedI26012914: "VIDEOS",
//     unselectedI26012915: "INSIGHTS",
//     unselectedI26012916: "BLOGS",
//     text108: "FAQ’S",
//     unselectedI26012917: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton222Data,
// };

const x11FAQsPageDesktopData = {
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-3@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-3@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-3@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-3@1x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-3@1x.svg",
    bigrid3x2GapProps: bigrid3x2GapData,
    bigrid3x2Gap2Props: bigrid3x2Gap2Data,
    frame1590Props: frame1570Data,
    //headerWithBackground3Props: headerWithBackground32Data,
};

